<div mat-dialog-content class="form-container">
  <form [formGroup]="datosContratista">
    <h1>Alta Contratista</h1>
    <div>
      <h2>Datos Contratista</h2>
      <mat-form-field appearance="outline">
        <mat-label>Nombre Comercial del Contratista</mat-label>
        <input
          matInput
          placeholder="Nombre Comercial"
          formControlName="nombre"
          required
        />
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>CIF</mat-label>
        <input matInput placeholder="CIF" formControlName="cif" required />
        <mat-error>Por favor introduzca un número de CIF válido</mat-error>
      </mat-form-field>
    </div>
    <div>
      <h2>Información de Contacto</h2>
      <mat-form-field appearance="outline">
        <mat-label>Nombre y apellido de Contacto</mat-label>
        <input
          matInput
          placeholder="Nombre y apellido Contacto"
          formControlName="nombreContacto"
          required
        />
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>Mail de Contacto</mat-label>
        <input
          matInput
          placeholder="mail"
          formControlName="mailContacto"
          required
        />
      </mat-form-field>
    </div>
    <div>
      <button
        type="submit"
        (click)="addContratista()"
        [mat-dialog-close]
        [disabled]="datosContratista.invalid"
      >
        Hecho
      </button>
    </div>
  </form>
</div>
